function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.364 1h62.274A7.37 7.37 0 0178 8.364v62.274A7.37 7.37 0 0170.638 78H8.364A7.37 7.37 0 011 70.638V8.364A7.373 7.373 0 018.364 1zm62.274 73.305a3.667 3.667 0 003.667-3.667V8.364a3.667 3.667 0 00-3.667-3.666H8.364a3.667 3.667 0 00-3.666 3.666v62.274a3.667 3.667 0 003.666 3.667h62.274z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.845 0h62.313A8.854 8.854 0 0180 8.845v62.313A8.853 8.853 0 0171.158 80H8.845A8.854 8.854 0 010 71.158V8.845A8.856 8.856 0 018.845 0zm62.313 78.524a7.374 7.374 0 007.366-7.366V8.845a7.375 7.375 0 00-7.366-7.369H8.845a7.377 7.377 0 00-7.369 7.369v62.313a7.375 7.375 0 007.369 7.366h62.313z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.687 5h62.626A3.687 3.687 0 0175 8.687v62.626A3.687 3.687 0 0171.313 75H8.687A3.687 3.687 0 015 71.313V8.693a3.687 3.687 0 013.687-3.687V5z",
  fill: "#006ED2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.167 25H10v29h5.337V43.237h4.807L25.85 54H32l-6.396-11.79c1.63-.494 5.662-2.424 5.662-7.968 0-3.37-1.384-5.67-3.177-7.148-2.492-2.025-5.022-2.052-8.767-2.092L19.167 25zm-3.83 13.763v-9.078h2.485c3.193 0 4.572.039 5.703.626a4.153 4.153 0 012.283 3.892c0 4.232-3.872 4.435-5.052 4.477l-.397.017c-.83.035-1.562.066-3.147.066h-1.875z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M46 24.012V54h-5.551V36.85c0-2.843 0-3.685-2.482-3.685H33v-3.437h.582c2.843-.043 6.692-.089 7.9-5.728l4.518.012z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.911 54c6.44 0 11.086-3.453 11.086-8.762H71c0-2.69-1.141-5.195-4.559-6.864 2.805-1.338 3.858-3.54 3.858-6.085 0-5.05-3.988-8.289-10.08-8.289-6.355 0-10.168 3.497-10.168 8.03 0 1.725.658 4.878 3.813 6.344-1.492.693-4.864 2.287-4.864 6.864C49 50.288 53.163 54 59.911 54zm-4.242-21.308c0 1.294.565 3.84 4.556 3.84 3.462 0 4.338-2.2 4.338-3.84 0-3.325-2.672-3.928-4.38-3.928-3.726-.045-4.52 2.328-4.52 3.928h.006zM55.18 45.08c0 2.46 1.754 4.143 4.996 4.143 2.848 0 4.952-1.467 4.952-4.188 0-.517-.088-4.143-4.952-4.143-4.688 0-4.996 3.28-4.996 4.174v.014z",
  fill: "#fff"
});

function SvgRatingR18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgRatingR18;